import Loadable from '../../components/Loadable';
import { lazy } from 'react';
import {FeedbackProvider} from "../../contexts/feedbackContext/FeedbackContext";

const FeedbackFragment = Loadable(lazy(() => import('./views/FeedbackFragment')));

const feedbackRoutes = [
    { path: '/feedback', element: <FeedbackProvider><FeedbackFragment /></FeedbackProvider> },
];

export default feedbackRoutes;
